const positionMap = {
  "top": "t",
  "middle": "c",
  "bottom": "b",
  "left": "l",
  "center": "c",
  "right": "r"
};
function mapPosition(label) {
  if (label.position.indexOf("-") === -1)
    return label;
  const position = label.position || "top-right";
  let [v, h] = position.split("-");
  v = positionMap[v] ? positionMap[v] : "t";
  h = positionMap[h] ? positionMap[h] : "r";
  label.position = v + h;
  return label;
}
function useProductLabels() {
  function getLabels(product) {
    const { product_labels } = product;
    if (!product_labels || !product_labels.length)
      return [];
    return product_labels.filter((l) => {
      var _a;
      const isVisible = (_a = l.is_visible) != null ? _a : false;
      if (l.txt === "-0%")
        return false;
      return isVisible;
    }).map(mapPosition);
  }
  return {
    getLabels
  };
}
export * from "./useProductLabels";
var useProductLabels_default = useProductLabels;
export {
  useProductLabels_default as default,
  useProductLabels
};
